
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/ai-knowledge-management-solutions",
      function () {
        return require("private-next-pages/services/ai-knowledge-management-solutions.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/ai-knowledge-management-solutions"])
      });
    }
  